export enum SyncingStatus {
    FailedToSync = 'FailedToSync',
    Syncing = 'Syncing'
}
